import ProfileConfigurePane from './ProfileConfigurePane';
import ProfilePane from './ProfilePane';
import RootMasqueradePane from './RootMasqueradePane';

export const panes = {
  ProfileConfigurePane,
  ProfilePane,
  RootMasqueradePane,
};
